module.exports = __webpack_public_path__ + "static/media/DC_O_Timeless_Sforza_Sand.9d436af5.png";